import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-top-filter',
  templateUrl: './top-filter.component.html',
  styleUrls: ['./top-filter.component.scss'],
})
export class TopFilterComponent implements AfterViewChecked, AfterViewInit {

  @Input() states!: { key: string; value: string }[];
  @Input() executionMethod?: (sortOrder: any) => void;

  @Output() selectedIndexChange = new EventEmitter<number>();

  @ViewChildren('filterButton') filterButtons!: QueryList<ElementRef>;
  @ViewChild('indicator') indicator!: ElementRef<HTMLDivElement>;
  @ViewChild('buttonsWrapper') buttonsWrapper!: ElementRef<HTMLDivElement>;

  public selectedFilterIndex = 0;
  public isInitialized = false;
  public likeColumn = 1;

  constructor() {}

  ngAfterViewInit() {
    this.selectFilter(this.selectedFilterIndex, this.states[this.selectedFilterIndex].value);
  }

  ngAfterViewChecked() {
    this.updateIndicatorPosition();
  }

  selectFilter(index: number, filter: string) {
    this.selectedFilterIndex = index;
    this.selectedIndexChange.emit(index);
    this.updateIndicatorPosition();
    if (this.executionMethod) {
      this.executionMethod(filter);
    }
  }

  /**
   * Atualiza a posição do indicador principal.
   * Esta versão calcula a posição relativa ao 'buttonsWrapper' para maior robustez.
   */
  updateIndicatorPosition() {
    const buttonsArray = this.filterButtons?.toArray();
    if (!buttonsArray || buttonsArray.length === 0) {
      return;
    }

    const selectedButton = buttonsArray[this.selectedFilterIndex]?.nativeElement;
    if (!selectedButton) {
      return;
    }

    const spanElement = selectedButton.querySelector('span');
    const indicatorEl = this.indicator?.nativeElement;
    const container = this.buttonsWrapper?.nativeElement;

    if (spanElement && indicatorEl && container) {
      const containerRect = container.getBoundingClientRect();
      const spanRect = spanElement.getBoundingClientRect();
      
      // Calcula a posição X do span relativa ao container dos botões
      const relativeSpanX = spanRect.left - containerRect.left;
      
      indicatorEl.style.transform = `translateX(${relativeSpanX}px)`;
    }

    if (!this.isInitialized) {
      setTimeout(() => {
        this.isInitialized = true;
      }, 100);
    }
  }
  /**
   * Dispara a animação da bolinha com efeito elástico.
   * @param start_index Índice do filtro de origem da animação.
   * @param to_index Índice do filtro de destino da animação.
   */
  triggerLikeAnimation() {
    const targetButtonId = `filter-button-${this.likeColumn}`;
    const animationClass = 'pulse-animation';

    this.handleAnimation(animationClass, targetButtonId, 0, 600);
  }

    handleAnimation(animation: string, targetId: string, delay: number, duration: number) {
    setTimeout(() => document.getElementById(targetId)?.classList.add(animation), delay);
    setTimeout(() => document.getElementById(targetId)?.classList.remove(animation), duration + delay);
  }
}